const EXPLOYEE_ORGANIZATIONS = {
  'GIATA_INTERNAL': {
    label: 'GIATA Internal',
    value: 1
  },
  'GIATA_EXTERNAL': {
    label: 'GIATA External',
    value: 2
  }
}
export {
  EXPLOYEE_ORGANIZATIONS
}
